import { Card } from '../card';
import { ListEmptyComponent } from '../chapters-list-empty';
import { useMissionStore } from '../../../shared/store/useMissionStore';
import { ComponentMissionChapters } from '@edwin-group/cj-graphql';

export const ChaptersList = ({ headerComponent }: { headerComponent: () => React.ReactNode }) => {
  const mission = useMissionStore((state) => state.mission);

  if (!mission) {
    return null;
  }

  return (
    <div className="mt-sh-30 flex flex-col gap-4">
      {headerComponent()}
      {mission?.chapters?.length === 0 ? (
        <ListEmptyComponent />
      ) : (
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          {mission?.chapters?.map((chapter, index) => (
            <div key={chapter?.uuid} id={`${chapter?.uuid}`} className="scroll-mt-[24px]">
              <Card
                chapterId={`${mission?.documentId}/${chapter?.uuid}`}
                trait={mission?.trait}
                chapter={chapter as ComponentMissionChapters}
                index={index}
                missionSlug={mission.slug}
                totalChapters={mission?.chapters?.length || 0}
              />
              <div className="h-7.5" />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
